import { useState } from 'react'
import styled from '@emotion/styled'

const DROPZONE_STATES = {
  INVALID: -1,
  READY: 0,
  VALID: 1,
}

export const FileDropZone = ({ expectedMimeTypes, handleDrop, children }) => {
  const [dropZoneState, setDropZoneState] = useState(0)

  return (
    <DropZone
      dropZoneState={dropZoneState}
      onDrop={e => {
        e.preventDefault()
        setDropZoneState(0)
        handleDrop(e)
      }}
      onDragOver={e => e.preventDefault()}
      onDragEnter={e => {
        e.preventDefault()
        const file = e.dataTransfer.items[0]
        const isValidFile = file.kind === 'file' && expectedMimeTypes.includes(file.type)
        setDropZoneState(isValidFile ? 1 : -1)
      }}
      onDragLeave={e => {
        e.preventDefault()
        setDropZoneState(0)
      }}
      data-testid="file-drop-zone"
    >
      {children}
    </DropZone>
  )
}

const dropZoneBackgroundColors = {
  [DROPZONE_STATES.INVALID]: 'rgba(255, 81, 81, 0.1)',
  [DROPZONE_STATES.READY]: '',
  [DROPZONE_STATES.VALID]: 'rgba(0, 100, 100, 0.1)',
}

const dropZoneBoxShadows = {
  [DROPZONE_STATES.INVALID]: '',
  [DROPZONE_STATES.READY]: '',
  [DROPZONE_STATES.VALID]: '0 0 10px -2px rgba(0, 0, 0, 0.5)',
}

const dropZoneTransforms = {
  [DROPZONE_STATES.INVALID]: 'perspective(1px) translateZ(0) scale(0.95)',
  [DROPZONE_STATES.READY]: 'perspective(1px) translateZ(0) scale(1)',
  [DROPZONE_STATES.VALID]: 'perspective(1px) translateZ(0) scale(1.05)',
}

const DropZone = styled.div`
  align-items: center;
  background-color: ${props => dropZoneBackgroundColors[props.dropZoneState]};
  border-radius: 2px;
  border: 2px dashed rgba(0, 0, 0, 0.54);
  box-shadow: ${props => dropZoneBoxShadows[props.dropZoneState]};
  cursor: ${props => (props.dropZoneState === -1 ? 'not-allowed' : '')};
  display: flex;
  flex-direction: column;
  height: 90%;
  justify-content: space-between;
  margin: 12px;
  min-height: 300px;
  padding: 20px 20px;
  text-align: center;
  transform: ${props => dropZoneTransforms[props.dropZoneState]};
  transition-duration: 0.3s;
  transition-property: box-shadow, transform;
  width: 100%;
  & * {
    pointer-events: ${props => (!props.dropZoneState ? 'all' : 'none')};
  }
`
